import { render } from "./ServiceDetailsStackedHistogram.vue?vue&type=template&id=2a01f6c7"
import script from "./ServiceDetailsStackedHistogram.vue?vue&type=script&lang=js"
export * from "./ServiceDetailsStackedHistogram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__